export const searchTheme = {
    title: 'Explore a THEME',
    description:
        'You can search for a theme to analyze from multiple approaches. Please select the tab that corresponds to your purpose.',
    searchFromList: 'Search from Theme List',
    searchFromCompany: 'Search from Company',
    searchFromTechnology: 'Search by technology',
    searchFromTrends: 'Search by theme trends'
}
